import { render, staticRenderFns } from "./DashIntakeNewCases.vue?vue&type=template&id=71e4878a&scoped=true&"
import script from "./DashIntakeNewCases.vue?vue&type=script&lang=js&"
export * from "./DashIntakeNewCases.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e4878a",
  null
  
)

export default component.exports